export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.8afd9439.worker.js");
}
